<template>
  <div class="container-fluid">
    <!--CERTIFICATE HEADER -->
    <h2
      class="text-center fw-bolder display-4 text-uppercase text-dark mb-0"
      id="certificates"
    >
      Certificates
    </h2>
    <!--DIVIDER LINE -->
    <div class="divider-custom">
      <div class="divider-custom-line" />
      <div class="divider-custom-icon">
        <i class="fas fa-certificate fs-1 text-dark"></i>
      </div>
      <div class="divider-custom-line" />
    </div>

    <certificate-body />
  </div>
</template>

<script>
import CertificateBody from "./CertificateBody.vue";

export default {
  name: "certificate-content",
  components: {
    CertificateBody,
  },
};
</script>

<style >
h2 {
  margin-top: 5rem;
}
img {
  max-width: 800px;
  max-height: 450px;
}
.divider-custom {
  margin: 1.25rem 0 1.5rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.divider-custom .divider-custom-line {
  width: 100%;
  max-width: 10rem;
  height: 0.3rem;
  background-color: #222831;
  border-radius: 1rem;
  border-color: #222831 !important;
}
</style>